import { createRouter, createWebHistory } from "vue-router";
import LoginPage from "@/components/auth/LoginPage.vue";
import RecuperarContrasena from "@/components/auth/RecuperarContrasena.vue";
import RecuperarContrasena_2 from "@/components/auth/RecuperarContrasena_2.vue";
import Homepage from "@/components/Homepage.vue";
import ErrorPage from "@/components/ErrorPage.vue";
import MenuEmbargos from "@/components/menus/MenuEmbargos.vue";
import MenuReservas from "@/components/menus/MenuReservas.vue";
import MenuRendimientos from "@/components/menus/MenuRendimientos.vue";
import MenuAdministracion from "@/components/menus/MenuAdministracion.vue";
import UsuariosAdministracion from "@/components/auth/UsuariosAdministracion.vue";
import RolesAdministracion from "@/components/auth/RolesAdministracion.vue";
import PermisosAdministracion from "@/components/auth/PermisosAdministracion.vue";
import MenusAdministracion from "@/components/auth/MenusAdministracion.vue";
import TasasEA from "@/components/rendimientos/TasasEA.vue";
import InformacionRendimientos from "@/components/rendimientos/InformacionRendimientos.vue";
import ExtractosBancarios from "@/components/rendimientos/ExtractosBancarios.vue";
import ReservasPresupuestales from "@/components/reservas/ReservasPresupuestales.vue";
import GestionarReservas from "@/components/reservas/GestionarReservas.vue";
import GestionarCobroSaldo from "@/components/reservas/GestionarCobroSaldo.vue";
import FuentesMacro from "@/components/parametros/FuentesMacro.vue";
import FuentesConcretas from "@/components/parametros/FuentesConcretas.vue";
import Rubros from "@/components/parametros/Rubros.vue";
import Contratos from "@/components/parametros/Contratos.vue";
import EmbargosInformes from "@/components/embargos/EmbargosInformes";
import Bancos from "@/components/parametros/Bancos";
import MacroEjecutor from "@/components/parametros/MacroEjecutores.vue";
import SecretariasEjecutoras from "@/components/parametros/SecretariasEjecutoras";
import TipoCaps from "@/components/parametros/TipoCaps.vue";
import MenuParametros from "@/components/menus/MenuParametros";
import MenuPerfil from "@/components/menus/MenuPerfil";
import CuentasBancarias from "@/components/parametros/CuentasBancarias";
import Beneficiarios from "@/components/parametros/Beneficiarios";
import EmbargosPersonas from "@/components/embargos/EmbargosPersonas";
import EmbargosGobernacion from "@/components/embargos/EmbargosGobernacion";
import PersonasCrud from "@/components/parametros/PersonasCrud";
import InformeLog from "@/components/auth/InformeLog.vue";
import EntidadCobroCoactivo from "@/components/parametros/EntidadCobroCoactivo.vue";
import JuzgadosCRUD from "@/components/parametros/JuzgadosCRUD.vue";
import TipoDocumento from "@/components/parametros/TipoDocumento.vue";
import ModalidadesLiquidacion from "@/components/parametros/ModalidadesLiquidacion.vue";
import ParametrosGenerales from "@/components/parametros/ParametrosGenerales.vue";
import TiposComprobanteSiiaf from "@/components/parametros/TiposComprobanteSiiaf.vue";
import EntidadesEmisoras from "@/components/parametros/EntidadesEmisoras.vue";
import Verificacion2FA from "@/components/auth/components/TwoFactorVerification.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: LoginPage,
    meta: {
      title: "Login | Tesorería",
    },
  },
  {
    path: "/recuperarContrasena",
    name: "RecuperarContrasena",
    component: RecuperarContrasena,
    meta: {
      title: "Recordar contraseña | Tesorería",
    },
  },
  {
    path: "/recuperarContrasena_2/:rememberToken",
    name: "RecuperarContrasena_2",
    component: RecuperarContrasena_2,
    meta: {
      title: "Cambiar contraseña | Tesorería",
    },
  },
  {
    path: "/inicio",
    name: "homepage",
    component: Homepage,
    meta: {
      title: "Inicio | Tesorería",
    },
  },
  {
    path: "/perfil",
    name: "Perfil",
    component: MenuPerfil,
    meta: {
      title: "Inicio | Tesorería",
    },
  },
  {
    path: "/administracion",
    name: "MenuAdministracion",
    component: MenuAdministracion,
    meta: {
      title: "Administración | Tesorería",
    },
    children: [
      {
        path: "usuarios",
        name: "UsuariosAdministracion",
        component: UsuariosAdministracion,
        meta: {
          title: "Usuarios | Tesorería",
        },
      },
      {
        path: "roles",
        name: "RolesAdministracion",
        component: RolesAdministracion,
        meta: {
          title: "Roles | Tesorería",
        },
      },
      {
        path: "permisos",
        name: "PermisosAdministracion",
        component: PermisosAdministracion,
        meta: {
          title: "Permisos | Tesorería",
        },
      },
      {
        path: "menus",
        name: "MenusAdministracion",
        component: MenusAdministracion,
        meta: {
          title: "Menus | Tesorería",
        },
      },
      {
        path: "log",
        name: "InformeLog",
        component: InformeLog,
        meta: {
          title: "Log | Tesorería",
        },
      },
    ],
  },
  {
    path: "/embargos",
    name: "MenuEmbargos",
    component: MenuEmbargos,
    meta: {
      title: "Embargos | Tesorería",
    },
    children: [
      {
        path: "embargosInformes",
        name: "EmbargosInformes",
        component: EmbargosInformes,
        meta: {
          title: "Informe de los Embargos | Tesorería",
        },
      },
      {
        path: "embargosPersonas",
        name: "EmbargosPersonas",
        component: EmbargosPersonas,
        meta: {
          title: "Embargos Personas | Tesorería",
        },
      },
      {
        path: "embargosGobernacion",
        name: "EmbargosGobernacion",
        component: EmbargosGobernacion,
        meta: {
          title: "Embargos Gobernación | Tesorería",
        },
      },
    ],
  },
  {
    path: "/reservas",
    name: "MenuReservas",
    component: MenuReservas,
    meta: {
      title: "Reservas | Tesorería",
    },
    children: [
      {
        path: "reservasPresupuestales",
        name: "ReservasPresupuestales",
        component: ReservasPresupuestales,
        meta: {
          title: "Reservas Presupuestales | Tesorería",
        },
      },
      {
        path: "gestionarReservas",
        name: "GestionarReservas",
        component: GestionarReservas,
        meta: {
          title: "Gestionar Reservas | Tesorería",
        },
      },
      {
        path: "gestionarCobroSaldo",
        name: "GestionarCobroSaldo",
        component: GestionarCobroSaldo,
        meta: {
          title: "Gestionar Cobro y Saldo | Tesorería",
        },
      },
    ],
  },
  {
    path: "/rendimientos",
    name: "MenuRendimientos",
    component: MenuRendimientos,
    meta: {
      title: "Rendimientos | Tesorería",
    },
    children: [
      {
        path: "tasaseinteres",
        name: "TasasEA",
        component: TasasEA,
        meta: {
          title: "Tasa e Interes | Tesorería",
        },
      },
      {
        path: "informacion",
        name: "InformacionRendimientos",
        component: InformacionRendimientos,
        meta: {
          title: "Información Rendimientos | Tesorería",
        },
      },
      {
        path: "financiero",
        name: "ExtractosBancarios",
        component: ExtractosBancarios,
        meta: {
          title: "Rendimientos | Tesorería",
        },
      },
    ],
  },
  {
    path: "/parametros",
    name: "MenuParametros",
    component: MenuParametros,
    meta: {
      title: "Parametros | Tesorería",
    },
    children: [
      {
        path: "bancos",
        name: "BancosCRUD",
        component: Bancos,
        meta: {
          title: "Bancos | Tesorería",
        },
      },
      {
        path: "cuentasBancarias",
        name: "CuentasBancariasCRUD",
        component: CuentasBancarias,
        meta: {
          title: "Cuentas Bancarias | Tesorería",
        },
      },
      {
        path: "macroEjecutor",
        name: "MacroEjecutorCRUD",
        component: MacroEjecutor,
        meta: {
          title: " Macro Ejecutor | Tesorería",
        },
      },
      {
        path: "secretariasEjecutoras",
        name: "SecretariasEjecutorasCRUD",
        component: SecretariasEjecutoras,
        meta: {
          title: "Secretarías Ejecutoras | Tesorería",
        },
      },
      {
        path: "contratos",
        name: "ContratosCRUD",
        component: Contratos,
        meta: {
          title: "Contratos | Tesorería",
        },
      },
      {
        path: "tipoCap",
        name: "TipoCapsCRUD",
        component: TipoCaps,
        meta: {
          title: "Tipo Caps | Tesorería",
        },
      },
      {
        path: "modalidadesLiquidacion",
        name: "ModalidadesLiquidacionCRUD",
        component: ModalidadesLiquidacion,
        meta: {
          title: "Modalidades de Liquidación | Tesorería",
        },
      },
      {
        path: "parametrosGenerales",
        name: "ParametrosGeneralesCRUD",
        component: ParametrosGenerales,
        meta: {
          title: "Parámetros Generales | Tesorería",
        },
      },
      {
        path: "tiposComprobanteSiiaf",
        name: "TiposComprobanteSiiafCRUD",
        component: TiposComprobanteSiiaf,
        meta: {
          title: "Tipos de Comprobante SIIAF | Tesorería",
        },
      },
      {
        path: "entidadesEmisoras",
        name: "EntidadesEmisorasEmbargoCRUD",
        component: EntidadesEmisoras,
        meta: {
          title: "Entidades Emisoras de Embargo | Tesorería",
        },
      },
      {
        path: "fuentesMacro",
        name: "FuentesMacroCRUD",
        component: FuentesMacro,
        meta: {
          title: "Fuentes Macro | Tesorería",
        },
      },
      {
        path: "fuentesConcretas",
        name: "FuentesConcretasCRUD",
        component: FuentesConcretas,
        meta: {
          title: "Fuentes Concretas | Tesorería",
        },
      },
      {
        path: "rubros",
        name: "RubrosCRUD",
        component: Rubros,
        meta: {
          title: "Rubros | Tesorería",
        },
      },
      {
        path: "beneficiarios",
        name: "BeneficiariosCRUD",
        component: Beneficiarios,
        meta: {
          title: "Beneficiarios | Tesorería",
        },
      },
      {
        path: "personas",
        name: "PersonasCrud",
        component: PersonasCrud,
        meta: {
          title: "Personas | Tesorería",
        },
      },
      {
        path: "juzgados",
        name: "JuzgadosCRUD",
        component: JuzgadosCRUD,
        meta: {
          title: "Juzgado | Tesorería",
        },
      },
      {
        path: "entidad",
        name: "EntidadCobroCoactivo",
        component: EntidadCobroCoactivo,
        meta: {
          title: "Entidad - Cobro Coactivo | Tesorería",
        },
      },
      {
        path: "tipoDocumento",
        name: "TipoDocumento",
        component: TipoDocumento,
        meta: {
          title: "Tipo Documento | Tesorería",
        },
      },
    ],
  },
  {
    path: "/:catchAll(.*)",
    name: "ErrorPage",
    component: ErrorPage,
    meta: {
      title: "Error | Tesorería",
    },
  },
  {
    path: '/verificacion-2fa',
    name: 'Verificacion2FA',
    component: Verificacion2FA,
    meta: { 
      title: "Factor de Doble Autenticación | Tesorería",
      requiresPreAuth: true 
    }
  }
];

const router = createRouter({
  // BASE_URL lo inyecta Vue CLI con el publicPath del build, de modo que el
  // enrutado funcione tanto en la raíz del dominio como bajo un subdirectorio.
  history: createWebHistory(process.env.BASE_URL),
  routes,
});
router.beforeEach((to, from, next) => {
  document.title = to.meta.title;
  next();
});

export default router;
